import { render } from "./ExtraQuestionCheckBox.vue?vue&type=template&id=f87fbe3e&scoped=true"
import script from "./ExtraQuestionCheckBox.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionCheckBox.vue?vue&type=script&lang=js"

import "./ExtraQuestionCheckBox.vue?vue&type=style&index=0&id=f87fbe3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87fbe3e"]])

export default __exports__